import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { loadPhotos } from "../../../features/photo/photoSlice";
import { getUserState, getPhotoState } from "../../../app/selector";
import PhotoStepper from "../photo/PhotoStepper";
import PhotoThumbnail from "../photo/PhotoThumbnail";
import UploadButton from "../button/UploadButton";
import { BACKEND_URL } from "constants";

const SendRequest = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector(getUserState);
  const { photoLoaded, photoById } = useSelector(getPhotoState);

  const [requestedPhoto, setRequestedPhoto] = useState(undefined);
  
  // Capture fromPage so we can return to the exact same page
  const fromPage = location.state?.fromPage || location.state?.targetPage || 1;

  const photos = Object.values(photoById);
  const { photo_id } = useParams();

  useEffect(() => {
    if (!photoLoaded && user) {
      const payload = {
        user_id: user.user_id,
      };

      axios
        .post(BACKEND_URL + "/photos/by_user_id", payload)
        .then((response) => {
          dispatch(
            loadPhotos({
              photos: response.data,
            })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [photoLoaded, dispatch, user]);

  useEffect(() => {
    if (photo_id != null) {
      const payload = {
        photo_ids: [photo_id],
      };

      axios
        .post(BACKEND_URL + "/photos/by_id", payload)
        .then((response) => {
          if (response.data.length > 0) {
            setRequestedPhoto(response.data[0]);
          } else {
            console.error("cannot load requested photo");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [photo_id]);

  const renderRequestedPhoto = (photo) => {
    return (
      <div className="requested-photo-wrapper">
        <PhotoThumbnail
          thumbnailClass="shared-photo-thumbnail requested-thumbnail"
          src={`data:image/jpeg;base64,${photo["photo"]}`}
          photoId={photo["photo_id"]}
        />
      </div>
    );
  };

  const renderOwnPhotos = () => {
    return (
      <div className="own-photos-wrapper">
        <PhotoStepper photos={photos} requestedPhoto={requestedPhoto} returnPage={fromPage} />
      </div>
    );
  };

  if (requestedPhoto === undefined) {
    return null; 
  }

  return (
    <div className="content-block send-request-body">

      {/* SECTION 1: THEIRS */}
      <section className="exchange-section theirs">
        <h2 className="section-label">The photo you're matching</h2>
        {renderRequestedPhoto(requestedPhoto)}
      </section>

      {/* VISUAL DIVIDER */}
      <div className="exchange-divider">
        <span className="divider-icon">⇌</span>
      </div>

      {/* SECTION 2: YOURS */}
      <section className="exchange-section yours">
        <h2 className="section-label">
          {photos.length > 0
            ? "Select a photo to share in return"
            : "Upload a photo to complete the exchange"}
        </h2>
        {photos.length > 0 ? (
          renderOwnPhotos()
        ) : (
          <div className="upload-wrapper">
            <UploadButton />
          </div>
        )}
      </section>
    </div>
  );
};

export default SendRequest;